import React from 'react';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Button } from '..';
import { ImageLateCheckOut } from '../../assets/images';
import './LateCheckOutModal.scss';
import { AppRoutes } from '../../routes';
import { TranslationUtils } from '../../utils';

interface LateCheckOutModalProps {
    message: string;
    show: boolean;
    handleClose: () => any;
}

export const LateCheckOutModal: React.FC<LateCheckOutModalProps> = (props) => {
    const { show, handleClose, message } = props;
    const history = useHistory();

    const onClick = () => {
        history.push({
            pathname: AppRoutes.MODIFY_TRIP_ADJUSTMENTS.replace(':adjustment', 'late-checkout'),
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton />

            <div className="late-checkout-modal">
                <div className="modal-body">
                    <div className="modal-text">
                        <h4>{TranslationUtils.get('stay_longer')}</h4>
                        <p>{message}</p>
                    </div>
                    <div className="late-checkout-modal-image">
                        <ImageLateCheckOut />
                    </div>
                </div>

                <div className="modal-buttons">
                    <Button
                        id="button-cancel-late-checkout"
                        variant="default"
                        label={TranslationUtils.get('no_thanks')}
                        onClick={handleClose}
                    />

                    <Button
                        id="button-purchase-late-checkout"
                        variant="primary"
                        label={TranslationUtils.get('purchase')}
                        onClick={onClick}
                    />
                </div>
            </div>
        </Modal>
    );
};
